// Shared legal-route path constants for betonijerry.
//
// The Gate-1 wizard acceptance copy (checkbox label + Lue lisää details) and the
// stamped TERMS_VERSION now live in the DB (legalDocuments BETONIJERRY_REQUEST_CONSENT,
// ownerAsiakasId=1349) and are fetched at runtime; the bundled fallback lives in
// src/utils/legal/acceptanceCopy.js. The /kayttoehdot and /tietosuoja pages fetch
// the full Käyttöehdot / Tietosuoja markdown via /api/legal-documents/current/*.

export const KAYTTOEHDOT_ROUTE = "/kayttoehdot";
export const TIETOSUOJA_ROUTE = "/tietosuoja";
